import { render, staticRenderFns } from "./detail_sections.vue?vue&type=template&id=65490236&scoped=true&lang=html&"
import script from "./detail_sections.vue?vue&type=script&lang=js&"
export * from "./detail_sections.vue?vue&type=script&lang=js&"
import style0 from "./detail_sections.vue?vue&type=style&index=0&id=65490236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65490236",
  null
  
)

export default component.exports